<template>
  <main>
    <!-- ===== Hero ===== -->
    <div class="bg-img-hero position-relative overflow-hidden" :style="{'background-image': 'url(' + require('@/assets/svg/components/ben-solution-hero.svg') + ')'}">
      <div class="container space-top-3 space-bottom-2">
        <div class="w-lg-65 text-center mx-lg-auto">
          <img class="img-fluid mb-6" src="@/assets/img/products/fabrixai-logo.svg" style="max-width:15rem">
          <h1 class="mb-3">Enterprise Power, Without Enterprise Size</h1>
          <p class="lead">A proud strategic partner of beNovelty, empowering teams with an AI virtual workforce that handles repetitive tasks, preserves institutional expertise, and accelerates progress, so people can focus on what truly matters.</p>
          <a class="btn btn-primary transition-3d-hover mt-3" href="https://www.fabrixai.com/" target="_blank">Learn More <i class="fas fa-external-link-alt ml-1" /></a>
        </div>
        <!-- <div class="position-relative w-90 w-md-75 mx-auto mt-6">
          <div class="position-relative z-index-2" data-aos="fade-up" data-aos-offset="-50">
            <img class="img-fluid rounded-lg" src="@/assets/img/products/fiberconnect/fiber-hero-img.png" alt="FiberConnect Portals">
          </div>
        </div> -->
      </div>
    </div>
    <!-- ===== End Hero ===== -->

    <!-- ===== Core Philosophy ===== -->
    <div class="container space-2 space-lg-3">
      <div class="text-center mb-5">
        <h2>Where Innovation Meets Integrity</h2>
        <p class="lead">At FabriXAI, every AI journey starts and ends with people. They work alongside your teams, not as vendors, but as partners to design, test, and scale AI that creates real business impact.</p>
      </div>

      <div class="row">
        <!-- Pillar 1: Human-Centered -->
        <div class="col-12 col-md-6 col-lg-4 mb-4">
          <div class="card h-100 text-center p-4 transition-3d-hover">
            <div class="card-body">
              <div class="mb-4">
                <img class="img-fluid" src="@/assets/img/products/ai-agent.svg" alt="Human-Centered Approach" style="max-height: 120px;">
              </div>
              <h3 class="mb-3">Human-Centered Approach</h3>
              <p>Co-creating solutions that fit your culture and goals, ensuring AI works for your people.</p>
            </div>
          </div>
        </div>

        <!-- Pillar 2: Responsibly Engineered -->
        <div class="col-12 col-md-6 col-lg-4 mb-4">
          <div class="card h-100 text-center p-4 transition-3d-hover">
            <div class="card-body">
              <div class="mb-4">
                <img class="img-fluid" src="@/assets/img/products/seamless-embed.svg" alt="Responsibly Engineered" style="max-height: 120px;">
              </div>
              <h3 class="mb-3">Responsibly Engineered</h3>
              <p>Prebuilt assets and frameworks with transparent, auditable, and ethically aligned workflows.</p>
            </div>
          </div>
        </div>

        <!-- Pillar 3: Proven in Action -->
        <div class="col-12 col-md-6 col-lg-4 mb-4">
          <div class="card h-100 text-center p-4 transition-3d-hover">
            <div class="card-body">
              <div class="mb-4">
                <img class="img-fluid" src="@/assets/img/products/agentic-workflow.svg" alt="Proven in Action" style="max-height: 120px;">
              </div>
              <h3 class="mb-3">Proven in Action</h3>
              <p>Recognized by AWS GenAI Accelerator and Barclays Product Growth Programme for advancing Responsible AI.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ===== End Core Philosophy ===== -->

    <!-- ===== CTA Section ===== -->
    <div class="bg-img-hero position-relative overflow-hidden text-center" :style="{'background-image': 'url(' + require('@/assets/svg/components/ben-about-hero.svg') + ')'}">
      <div class="container space-2">
        <div class="mb-6">
          <h2>Build Your AI Business with Impact</h2>
          <p>Transform your organization with confidence and integrity. FabriXAI partners with enterprises to turn AI ambition into measurable business outcomes.</p>
        </div>
        <a class="btn btn-primary transition-3d-hover" href="https://www.fabrixai.com/" target="_blank">Visit FabriXAI <i class="fas fa-external-link-alt ml-1" /></a>
      </div>
    </div>
    <!-- ===== End CTA Section ===== -->

  </main>
</template>

<script>
const $ = require('jquery')
import HSGoTo from '@/assets/vendor/hs-go-to/src/js/hs-go-to'
import HSVideoPlayer from '@/assets/vendor/hs-video-player/src/js/hs-video-player'
import 'bootstrap'
import '@/assets/js/hs.core.js'
import { mapGetters } from 'vuex'
export default {
  name: 'FabriXAI',
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters([
    ])
  },
  mounted() {
    $('.js-go-to').each(function() {
      new HSGoTo($(this)).init()
    })
    $('.js-inline-video-player').each(function() {
      new HSVideoPlayer($(this)).init()
    })
    $('#videoModal').on('hidden.bs.modal', function(e) {
      $('#videoModal iframe').attr('src', $('#videoModal iframe').attr('src'))
    })
  },
  created() {
  },
  methods: {
  },
  metaInfo() {
    return {
      title: 'beNovelty',
      titleTemplate: 'FabriXAI | Partners | %s',
      link: [
        { rel: 'canonical', href: 'https://www.benovelty.com/partners/fabrixai' }
      ],
      meta: [
        { name: 'description', content: 'Discover beNovelty\'s state-of-the-art API-First and intelligent Agentic AI Solutions, designed to elevate your enterprise\'s digital transformation.' },
        { property: 'og:site_name', content: 'beNovelty' },
        { property: 'og:title', content: 'FabriXAI | Enterprise AI Solutions | beNovelty Partner' },
        { property: 'og:description', content: 'Empower your team with AI virtual workforce from FabriXAI—a beNovelty partner delivering enterprise-grade AI solutions with Responsible AI governance.' },
        { property: 'og:image', content: 'https://www.benovelty.com/assets/img/thumbnails/common.jpg' },
        { property: 'og:url', content: 'https://www.benovelty.com/partners/fabrixai' },
        { name: 'twitter:card', content: 'summary_large_image' }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>

<style>
.video-player-icon-primary{
  color: #ffffff;
  background-color: #57abf0;
}

.video-player-btn:hover .video-player-icon-primary {
  color: #ffffff;
  background-color: #57abf0;
  box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);
  -webkit-transform: scale(1.1);
          transform: scale(1.1);
}

.video-player-icon-pill {
  width: 100%;
  min-width: 13rem;
  height: 100%;
  padding: 0.75rem 1rem;
  border-radius: 3.125rem;
  font-size: 1rem;
  font-weight: 600;
}
</style>

